export default __webpack_public_path__ + "img/a71a070c97f41cb3b2c87fd6f37b7360.svg";